export const GET_USERS = "GET_USERS"
export const DELETE_USER  = "DELETE_USER"
export const DATE_TIME = "DATE_TIME"
export const HOURS_PAY = "HOURS_PAY"
export const TIMELINE_VEH = "TIMELINE_VEH"
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const CITY = "CITY"
export const VEHICLE_BOOK = "VEHICLE_BOOK"
export const RIDE_AMOUNT = "RIDE_AMOUNT"
export const LOGIN_CHECK = "LOGIN_CHECK"



